let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  });

var swiper = new Swiper(".image-text-swiper", {
  autoplay: true,
  spaceBetween: 16,
  slidesPerView: 1,
  navigation: false,
  pagination: false,
  autoHeight: true,
  grabCursor: true
});

if (document.body.clientWidth < 750) {
  var mb_swiper = new Swiper(".ct-icon-text_swiper", {
    spaceBetween: 16,
    slidesPerView: 1,
    navigation: {
      nextEl: '.ct-icon-text_swiper .ct-swiper-arrow-next', 
      prevEl: '.ct-icon-text_swiper .ct-swiper-arrow-prev',
    },
    pagination: false,
    grabCursor: true
  });
}

var mb_swiper = new Swiper(".ct-product-list_swiper", {
  spaceBetween: 17,
  slidesPerView: 1.5,
  navigation: {
    nextEl: '.ct-product-list_swiper .ct-swiper-arrow-next', 
    prevEl: '.ct-product-list_swiper .ct-swiper-arrow-prev',
  },
  pagination: {
    el: ".ct-product-list_swiper .swiper-pagination",
    type: "progressbar"
  },
  grabCursor: true,
  breakpoints: {
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});

var ingredient_swiper = new Swiper(".ingredient-vertical-slider", {
  slidesPerView: 1,
  pagination: {
    el: ".ingredient-vertical-slider .swiper-pagination",
    clickable: true
  },
  autoplay: true,
  grabCursor: true,
  breakpoints: {
    750: {
      slidesPerView: 1,
      direction: "vertical",
    },
  },
});

var testimonial_swiper = new Swiper(".testimonial-swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: false,
  centeredSlides: true,
  //autoHeight: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  breakpoints: {
    750: {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 50,
      autoHeight: false,
      loop: true,
    },
  },
});


let cart_swiper;
function initCartSwiper() {
  if (cart_swiper) {
    cart_swiper.destroy(true, true);
  }
   const ct_cart_swiper = new Swiper(".cart_product_list", {
      spaceBetween: 10,
      slidesPerView: 2,
      navigation: false,
      pagination: false,
      grabCursor: true,
      breakpoints: {
        990: {
          slidesPerView: 3.5,
          spaceBetween: 15,
        },
      },
    });
}
initCartSwiper();


// (function () {
//   const quantityContainer = document.querySelectorAll(".cstm_quantity_card .quantity");
//   quantityContainer.forEach(quantity => {
    
  
//   const minusBtn = quantity.querySelector(".cstm_quantity_card .minus");
//   const plusBtn = quantity.querySelector(".cstm_quantity_card .plus");
//   const inputBox = quantity.querySelector(".cstm_quantity_card .input-box");

//   updateButtonStates();

//   quantity.addEventListener("click", handleButtonClick);
//   inputBox.addEventListener("input", handleQuantityChange);

//   function updateButtonStates() {
//     const value = parseInt(inputBox.value);
//     minusBtn.disabled = value <= 1;
//     plusBtn.disabled = value >= parseInt(inputBox.max);
//   }

//   function handleButtonClick(event) {
//     if (event.target.classList.contains("minus")) {
//       decreaseValue();
//     } else if (event.target.classList.contains("plus")) {
//       increaseValue();
//     }
//   }

//   function decreaseValue() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : Math.max(value - 1, 1);
//     inputBox.value = value;
//     updateButtonStates();
//     handleQuantityChange();
//   }

//   function increaseValue() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max));
//     inputBox.value = value;
//     updateButtonStates();
//     handleQuantityChange();
//   }

//   function handleQuantityChange() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : value;

//     // Execute your code here based on the updated quantity value
//     console.log("Quantity changed:", value);
//   }
//   });
// })();


// document.addEventListener("DOMContentLoaded", function () {
//   const productCards = document.querySelectorAll('.cstm_product-card');

//   productCards.forEach(card => {
//     const variantSelect = card.querySelector('.ct_select');
//     const priceEl = card.querySelector('.price');
//     const comparePriceEl = card.querySelector('.compared_price');
//     const variantIdInput = card.querySelector('.ct-product-variant-id');

//     if (!variantSelect) return;

//     variantSelect.addEventListener('change', function () {
//       const selectedOption = variantSelect.options[variantSelect.selectedIndex];
//       const price = selectedOption.getAttribute('data-price');
//       const comparePrice = selectedOption.getAttribute('data-compare-price');
//       const variantId = selectedOption.value;

//       if (priceEl) priceEl.innerHTML = price;

//       if (comparePrice) {
//         if (comparePriceEl) {
//           comparePriceEl.innerHTML = comparePrice;
//           comparePriceEl.style.display = 'block';
//         }
//       } else {
//         if (comparePriceEl) {
//           comparePriceEl.style.display = 'none';
//         }
//       }

//       if (variantIdInput) variantIdInput.value = variantId;
//     });
//   });
// });

// function ct_atc() {
// document.addEventListener("DOMContentLoaded", (event) => {
//   let product_card = document.querySelectorAll('.cstm_product-card');
//   product_card.forEach(card => {
//     let atc = card.querySelector('.ct-atc_button');
//     atc.addEventListener("click", (atc_button) => {
//     let quantity = parseInt(card.querySelector('.input-box').value);
//     let variant_id = card.querySelector('.ct_select').value;
//       atc_button.preventDefault();
//       var itemsArray = [];
//       let item_data = {
//         id: variant_id,
//         quantity: quantity
//       };
//       itemsArray.push(item_data);
//       console.log(itemsArray);
//       let data = {
//         items: itemsArray,
//         'sections': document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id),
//         'sections_url': window.location.pathname
//       }
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify(data)
//       })
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then(response =>{
//         console.log(response);
//         document.querySelector('cart-drawer').classList.remove('is-empty');
//         document.querySelector('cart-drawer').renderContents(response);
//         document.querySelector('cart-drawer').open();
//       })
//     });
//   });
// });
// }
// ct_atc();

function setupProductCard(card) {
  // VARIANT CHANGE
  const variantSelect = card.querySelector('.ct_select');
  const priceEl = card.querySelector('.price');
  const comparePriceEl = card.querySelector('.compared_price');
  const variantIdInput = card.querySelector('.ct-product-variant-id');

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const price = selectedOption.getAttribute('data-price');
      const comparePrice = selectedOption.getAttribute('data-compare-price');
      const variantId = selectedOption.value;

      if (priceEl) priceEl.innerHTML = price;
      if (comparePrice && comparePriceEl) {
        comparePriceEl.innerHTML = comparePrice;
        comparePriceEl.style.display = 'block';
      } else if (comparePriceEl) {
        comparePriceEl.style.display = 'none';
      }

      if (variantIdInput) {
        variantIdInput.value = variantId;
      }
    });
  }

  // QUANTITY BUTTONS
  const quantityWrapper = card.querySelector(".cstm_quantity_card .quantity");
  if (quantityWrapper) {
    const minusBtn = quantityWrapper.querySelector(".minus");
    const plusBtn = quantityWrapper.querySelector(".plus");
    const inputBox = quantityWrapper.querySelector(".input-box");

    if (inputBox && minusBtn && plusBtn) {
      minusBtn.setAttribute('type', 'button');
      plusBtn.setAttribute('type', 'button');

      function updateButtonStates() {
        const value = parseInt(inputBox.value);
        const max = parseInt(inputBox.getAttribute("max")) || 200;
        minusBtn.disabled = value <= 1;
        plusBtn.disabled = value >= max;
      }

      minusBtn.addEventListener("click", (e) => {
        e.preventDefault();
        inputBox.stepDown();
        updateButtonStates();
      });

      plusBtn.addEventListener("click", (e) => {
        e.preventDefault();
        inputBox.stepUp();
        updateButtonStates();
      });

      inputBox.addEventListener("input", () => {
        let value = parseInt(inputBox.value);
        const max = parseInt(inputBox.getAttribute("max")) || 200;

        if (isNaN(value) || value < 1) {
          inputBox.value = 1;
        } else if (value > max) {
          inputBox.value = max;
        }

        updateButtonStates();
      });

      updateButtonStates();
    }
  }

  // ADD TO CART
  const atcBtn = card.querySelector('.ct-atc_button');
  if (atcBtn) {
    atcBtn.addEventListener("click", (e) => {
      e.preventDefault();

      const quantityInput = card.querySelector('.input-box');
      const variantSelect = card.querySelector('.ct_select');
      const quantity = parseInt(quantityInput?.value || 1);
      const variantId = variantSelect?.value;

      if (!variantId || !quantity) return;

      const itemsArray = [{ id: variantId, quantity }];
      const cartDrawer = document.querySelector('cart-drawer');
      const data = {
        items: itemsArray,
        sections: cartDrawer?.getSectionsToRender()?.map((section) => section.id),
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to add to cart');
        return response.json();
      })
      .then(response => {
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
          cartDrawer.open();
        }
      })
      .catch(err => console.error('ATC Error:', err));
    });
  }
}

// INITIAL SETUP
function initProductCards() {
  document.querySelectorAll('.price_with_atc').forEach(card => {
    // Prevent duplicate binding
    if (!card.classList.contains('js-bound')) {
      card.classList.add('js-bound');
      setupProductCard(card);
    }
  });
}

// Run on DOM load
document.addEventListener("DOMContentLoaded", initProductCards);

// Run when dynamic content is added (related products)
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;

      // Look for added .price_with_atc cards
      if (node.matches('.price_with_atc')) {
        if (!node.classList.contains('js-bound')) {
          node.classList.add('js-bound');
          setupProductCard(node);
        }
      } else {
        // If a whole section was added (like .product-recommendations), search inside
        const newCards = node.querySelectorAll?.('.price_with_atc');
        newCards?.forEach(card => {
          if (!card.classList.contains('js-bound')) {
            card.classList.add('js-bound');
            setupProductCard(card);
          }
        });
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});





{
  let product_slides = document.querySelectorAll('#product-preview .images-wrapper .product-images');
  let slide_height = product_slides.item(0).offsetHeight;

  let active_slide;

  // Calculate which slide is active initially
  let dist_to_first_slide = window.pageYOffset + product_slides.item(0).getBoundingClientRect().top;
  if (window.pageYOffset <= dist_to_first_slide + slide_height / 2) {
    active_slide = 0;
  } else {
    active_slide = Math.floor((window.pageYOffset - dist_to_first_slide) / (slide_height / 2));
  }

  let dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;

  // On resize re-calculate distances
  window.addEventListener(
    'resize',
    () => {
      slide_height = product_slides.item(0).offsetHeight;

      dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;
    },
    true
  );

  document.addEventListener('scroll', (event) => {
    // Switch active product slide up or down so
    // we know which color to use, text to use, and slide dot to be on
    if (window.pageYOffset - dist_to_active_slide >= slide_height / 2 && active_slide < product_slides.length - 1) {
      active_slide += 1;
      dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;

      change_slide(active_slide);
    } else if (dist_to_active_slide - window.pageYOffset >= slide_height / 2 && active_slide >= 1) {
      active_slide -= 1;
      dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;

      change_slide(active_slide);
    }
  });

  function change_slide(active_slide) {
    let product_infos = document.querySelectorAll('#product-preview .info-wrapper .product-info');

    // Change the active product info
    product_infos.forEach((el, index) => {
      if (index == active_slide) {
        setTimeout(() => {
          el.style.display = 'flex';
          setTimeout(() => {
            el.style.opacity = '1';
          }, 10);
        }, 500);
      } else if (el.style.display == 'flex') {
        el.style.opacity = '0';
        setTimeout(() => {
          el.style.display = 'none';
        }, 500);
      }
    });

    // Change the circles color
    // let color_circles = document.querySelectorAll('#product-preview .circle-wrapper .color-circle');
    // color_circles.item(0).style['background-color'] = color_circles.item(active_slide + 1).style['background-color'];

    document.querySelectorAll('#product-preview .info-wrapper .nav-dots-wrapper .nav-dot').forEach((el, index) => {
      if (index == active_slide) {
        el.style['background-color'] = 'var(--ud-cocoa-900)';
      } else {
        el.style['background-color'] = 'unset';
      }
    });
  }

  // Add delay to fix double showing issue
  setTimeout(() => {
    change_slide(active_slide);
  }, 100);
}